import { Button, TextField } from "@mui/material";
import React, { useState } from "react";
import { sendUpdatedPassword } from "../../../../components/Shared/Utils/index.js";
import { isPasswordValid } from "../../../../components/Shared/Utils/isPasswordValid.js";

const ChangePassword = ({
  setIsEditingPassword,
  accessToken,
  setDisplayError,
  displayError,
  setSnackBarDisplayMessage,
  setSnackBarDisplaySeverity,
}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);
  const [isCurrentPasswordValid, setIsCurrentPasswordValid] = useState(false);

  // handlers

  const handleSavePassword = async () => {
    setIsLoading(true);
    try {
      const isUpdated = await sendUpdatedPassword(
        accessToken,
        currentPassword,
        newPassword,
        setDisplayError
      );
      if (isUpdated) {
        // Clear form only if the update was successful
        setIsEditingPassword(false);
        setCurrentPassword("");
        setNewPassword("");
        setSnackBarDisplayMessage("password updated");
        setSnackBarDisplaySeverity("success");
      }
    } catch (error) {
      // Catch-all for unexpected errors
      console.error("Unexpected error", error);
      setDisplayError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleNewPassword = (e) => {
    const newPassword = e.target.value;
    setNewPassword(newPassword);
    setIsNewPasswordValid(isPasswordValid(newPassword));
  };

  const handleCurrentPassword = (e) => {
    const currentPassword = e.target.value;
    setCurrentPassword(currentPassword);
    setIsCurrentPasswordValid(isPasswordValid(currentPassword));
  };

  const anyFieldHaveStringLength =
    currentPassword.length >= 1 || newPassword.length >= 1;

  const bothPasswordsAreUnique = currentPassword !== newPassword;

  const handleBlurNewPassword = () => {
    if (!anyFieldHaveStringLength) {
      setDisplayError("");
    }
    if (!isNewPasswordValid && newPassword.length >= 1) {
      setDisplayError(
        "Password: 7 char min, 1 uppercase, 1 lowercase, and 1 number"
      );
    } else if (!bothPasswordsAreUnique && anyFieldHaveStringLength) {
      setDisplayError("current and new password cannot be the same");
    } else {
      setDisplayError(""); // Clear error if the password is valid
    }
  };
  const handleBlurCurrentPassword = () => {
    if (!anyFieldHaveStringLength) {
      setDisplayError("");
    }
    if (!isCurrentPasswordValid && currentPassword.length >= 1) {
      setDisplayError(
        "Password: 7 char min, 1 uppercase, 1 lowercase, and 1 number"
      );
    } else if (!bothPasswordsAreUnique && anyFieldHaveStringLength) {
      setDisplayError("current and new password cannot be the same");
    } else {
      setDisplayError(""); // Clear error if the password is valid
    }
  };

  const isAllFieldsValid =
    isCurrentPasswordValid && isNewPasswordValid && bothPasswordsAreUnique;

  const inputStyle = {
    maxWidth: "75%",
  };

  const inputProps = {
    style: {
      width: "100%",
      margin: "0",
      color: "white",
      background: "transparent",
      boxSizing: "border-box",
      borderBottom: "1px solid grey",
    },
  };
  const inputLabelProps = {
    style: { color: "grey", paddingLeft: 0 },
  };
  return (
    <div>
      <TextField
        label="current password"
        type="text"
        value={currentPassword}
        onChange={handleCurrentPassword}
        onBlur={handleBlurCurrentPassword}
        fullWidth
        margin="normal"
        style={inputStyle}
        inputProps={inputProps}
        InputLabelProps={inputLabelProps}
        variant="standard"
      />
      <TextField
        label="new password"
        type="text"
        value={newPassword}
        onChange={handleNewPassword}
        onBlur={handleBlurNewPassword}
        fullWidth
        margin="normal"
        style={inputStyle}
        inputProps={inputProps}
        InputLabelProps={inputLabelProps}
        variant="standard"
      />
      <br></br>
      <div
        style={{
          minHeight: "1rem",
          maxWidth: "15rem",
          color: "rgb(154, 0, 0)",
        }}
      >
        {displayError}
      </div>
      {isAllFieldsValid && (
        <Button
          className="authButton"
          variant="contained"
          onClick={handleSavePassword}
          sx={{
            width: "25%",
            marginLeft: "75%",
            backgroundColor: "rgb(118 47 51)",
            textTransform: "none",
            minHeight: "2.3rem",
            "&:hover": {
              backgroundColor: "rgb(94, 38, 41)", // Prevent color change on hover
            },
            "&:focus": {
              backgroundColor: "rgb(94, 38, 41)", // Prevent color change on focus
            },
            "&:active": {
              backgroundColor: "rgb(94, 38, 41)", // Prevent color change when active (clicked)
              boxShadow: "none", // Disable any box shadow when active
            },
          }}
        >
          {isLoading ? <div className="spinner" /> : "update"}{" "}
        </Button>
      )}
    </div>
  );
};

export default ChangePassword;
